import { useCurrentUser, usePrevious } from '@lib/hooks';
import { useScheduleViewStorageVersion } from 'screens/nexty-next/ScheduleView/hooks';
import { useMemo } from 'react';

function useRUMData() {
  const user = useCurrentUser();
  const prevUserId = usePrevious(user?.id);

  const { scheduleStorageV2 } = useScheduleViewStorageVersion();

  const data = useMemo(() => {
    if (user && user?.id !== prevUserId) {
      return {
        id: user.id,
        rootId: user.user,
        name: user.name,
        email: user.email,
        role: user.roles,
        type: user.type,
        segment: user.salesforceData.boardSegment,
        healthStatus: user.salesforceData.healthStatus,
        specialty: user.salesforceData.specialty,
        providers: user.salesforceData.providers,
        scheduleViewV2: !!scheduleStorageV2,
        rolloutFlags: user.rollouts,
      };
    }
  }, [prevUserId, scheduleStorageV2, user]);

  return data;
}

export default useRUMData;
